import React, { Component } from "react"
import FooterBottom from "./Footer-Bottom"
import FooterWidgets from "./Footer-Widgets"
import "./index.css"

class Footer extends Component {
  render() {
    return (
      <React.Fragment>
        <FooterWidgets />
        <FooterBottom />
      </React.Fragment>
    )
  }
}

export default Footer
